import { useLocale } from "@/composables/use-locale";
import type { IDomainProductTag } from "@/domain/product-tag";

export const useProductTagLabel = () => {
  const { t, hasTranslation } = useLocale();

  const productTagLabels = (tags: IDomainProductTag[]): string[] => {
    return tags.flatMap((tag) => {
      if (tag.key === null) return [tag.name];

      const path = `composables.use_product_tag_label.${tag.key}`;

      return hasTranslation(path) ? [t(path)] : [];
    });
  };

  return { productTagLabels };
};
